<template>
  <b-container fluid class="my-4">
    <b-row>
      <b-col cols="12" md="8" lg="6" class="mx-auto">
        <b-card title="Editar terapia">
          <b-form @submit.prevent="submitForm">
            <b-form-group label="Nombre:" label-for="nombre">
              <b-form-input
                id="nombre"
                v-model="terapia.nombre"
                type="text"
                @input="saveToLocalStorage"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Código:" label-for="codigo">
              <b-form-input
                id="codigo"
                v-model="terapia.codigo"
                type="text"
                @input="saveToLocalStorage"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Precio Neto:" label-for="precio">
              <b-form-input
                id="precio"
                v-model="terapia.precio"
                type="text"
                @input="saveToLocalStorage"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Num Max:" label-for="numMax">
              <b-form-input
                id="numMax"
                v-model="terapia.numMax"
                type="number"
                @input="saveToLocalStorage"
                required
              ></b-form-input>
            </b-form-group>
            <hr />
            <label>Precios:</label>
            <b-row class="p-1 align-items-center">
              <b-col cols="6" md="4">
                <small>Iess</small>
                <b-form-input v-model="terapia.precioJson.iess_n1" type="text" />
              </b-col>
              <b-col cols="6" md="4">
                <small>Issfa N1</small>
                <b-form-input v-model="terapia.precioJson.issfa_n1" type="text" />
              </b-col>
              <b-col cols="6" md="4">
                <small>Issfa N2</small>
                <b-form-input v-model="terapia.precioJson.issfa_n2" type="text" />
              </b-col>
              <b-col cols="6" md="4">
                <small>Isspol</small>
                <b-form-input v-model="terapia.precioJson.isspol_n1" type="text" />
              </b-col>
              <b-col cols="6" md="4">
                <small>Particular</small>
                <b-form-input v-model="terapia.precioJson.particular" type="text" />
              </b-col>
            </b-row>
            <hr />
            <label>Activo/Inactivo</label>
            <b-row class="p-1">
              <b-col>
                <b-form-group label="Iess:" label-for="estado-1">
                  <b-form-checkbox id="estado-1" v-model="terapia.estadoJson.iess" switch />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Issfa:" label-for="estado-2">
                  <b-form-checkbox id="estado-2" v-model="terapia.estadoJson.issfa" switch />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Isspol:" label-for="estado-3">
                  <b-form-checkbox id="estado-3" v-model="terapia.estadoJson.isspol" switch />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Particular:" label-for="estado-4">
                  <b-form-checkbox id="estado-4" v-model="terapia.estadoJson.particular" switch />
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group label-for="tipoTerapia">
              <label>Tipo de terapia: <span class="text-danger">*</span></label>
              <validation-provider
                #default="{ errors }"
                name="tipoTerapia"
                rules="required"
              >
                <v-select
                  id="tipoTerapia"
                  v-model="terapia.tipoTerapia"
                  placeholder="Buscar por especialidad."
                  :options="tipoTerapias"
                  :reduce="(option) => option.value"
                  label="text"
                  class="d-inline-block w-100"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group label-for="establecimiento">
              <label>Establecimiento: <span class="text-danger">*</span></label>
              <validation-provider
                #default="{ errors }"
                name="establecimiento"
                rules="required"
              >
                <v-select
                  id="establecimiento"
                  v-model="terapia.establecimiento"
                  placeholder="Buscar por establecimiento."
                  :options="establecimientos"
                  :reduce="(option) => option.value"
                  label="text"
                  class="d-inline-block w-100"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group label="Estado:" label-for="estado-switch">
              <b-form-checkbox
                id="estado-switch"
                v-model="terapia.estado"
                value="1"
                unchecked-value="0"
                switch
              ></b-form-checkbox>
            </b-form-group>
            <b-button type="submit" variant="primary" @click="clearLocalStorage"
              >Actualizar terapia</b-button
            >
            <b-button @click="salir()" class="float-right" variant="danger"
              >Salir</b-button
            >
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  mounted() {
    this.loadFromLocalStorage();
  },
  data() {
    return {
      terapia: {
        id: "",
        nombre: "",
        codigo: "",
        precio: 0,
        numMax: 0,
        precioJson: { iess_n1: "", issfa_n1: "", issfa_n2: "", isspol_n1: "", particular: "" },
        estadoJson: { iess: true, issfa: true, isspol: true, particular: true },
        estado: 0,
        
       
      },
      tipoTerapia: "",
      tipoTerapias: [],
      establecimientos: [],
      allTipoTerapias: [],
      especialidad: "",
        especialidades: [],
    };
  },
  created() {
    const tokenTerapia = this.$route.params.token;
    this.fetchEstablecimientos();
    this.fetchTerapia(tokenTerapia);
    this.fetchTipoTerapias();
  },
  methods: {
    salir() {
      this.$router.push({ name: "consultar_cartera_terapia" });
    },
    saveToLocalStorage() {
      localStorage.setItem("terapia", JSON.stringify(this.terapia));
    },
    loadFromLocalStorage() {
      // Cargar los datos del localStorage solo si no se han cargado datos de la API
      if (!this.terapia.id) {
        const terapiaJSON = localStorage.getItem("terapia");
        if (terapiaJSON) {
          this.terapia = JSON.parse(terapiaJSON);
        }
      }
    },
    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        this.establecimientos = response.data.data.allEstablecimientos.map(
          (item) => ({
            value: item.id,
            text: item.Descripcion,
            uniCodigo: item.uniCodigo,
          })
        );
      } catch (error) {
        console.error("An error occurred while fetching the options:", error);
      }
    },
    async fetchTipoTerapias() {
      const query = `
    query obtenerTipoTerapia {
      allTipoterapias {
        id
        descripcion
      }
    }
  `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        // Mapear los datos para que sean compatibles con v-select
        this.tipoTerapias = response.data.data.allTipoterapias.map((item) => ({
          value: item.id,
          text: item.descripcion,
        }));
      } catch (error) {
        console.error("An error occurred while fetching the options:", error);
      }
    },

    async submitForm() {
      const precioNetoFormateado = parseFloat(this.terapia.precio).toFixed(4);
      const query = `
        mutation actualizarTerapia($terapiaDatos: TerapiaUpdateInput!) {
          actualizarTerapia(terapiaDatos: $terapiaDatos) {
            terapiaActualizado {
              token
              id
              codigo
              establecimiento {
                id
                Descripcion
              }
              tipoTerapia {
                id
                descripcion
              }
              precio
              estado
            }
            status
            message
          }
        }
      `;
      const variables = {
        terapiaDatos: {
          token: this.terapia.token,
          datos: {
            nombre: this.terapia.nombre,
            codigo: this.terapia.codigo,
            precio: precioNetoFormateado,
            numMax: this.terapia.numMax,
            establecimiento: this.terapia.establecimiento.value,
            tipoTerapiaId: this.terapia.tipoTerapia.value,
              
            estado: this.terapia.estado,
            precioJson: JSON.stringify(this.terapia.precioJson),
            estadoJson: JSON.stringify(this.terapia.estadoJson),
          },
        },
      };
      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });
        if (response.data.data.actualizarTerapia.status === "success") {
          await this.$swal({
            icon: "success",
            title: "Éxito",
            text: "La terapia se actualizó correctamente.",
          });
          this.$router.push({ name: "consultar_cartera_terapia" });
        } else {
          throw new Error(response.data.data.actualizarTerapia.message);
        }
      } catch (error) {
        await this.$swal({
          icon: "error",
          title: "Error",
          text: error.message || "Hubo un problema al actualizar la terapia.",
        });
      }
    },
    async fetchTerapia(tokenTerapia) {
  

      const query = `
        query ObtenerTerapia($tokenterapia: String!) {
          terapia(tokenterapia: $tokenterapia) {
            status
            message
            terapia {
              id
              token
              nombre
              codigo
              estado
              numMax
              precio
              precioJson
              estadoJson
              establecimiento {
                id
                Descripcion
              }
              tipoTerapia {
                id
                descripcion
              }
            }
          }
        }
      `;
      const variables = {
        tokenterapia: tokenTerapia,
      };
      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });
        if (response.data.data.terapia.status === "Success") {
          if (response.data.data.terapia.terapia) {
            const terapiaData = response.data.data.terapia.terapia;
            this.terapia = {
              id: terapiaData.id,
              token: terapiaData.token,
              nombre: terapiaData.nombre,
              codigo: terapiaData.codigo,
              estado: terapiaData.estado,
              numMax: terapiaData.numMax,
              precio: terapiaData.precio,
              precioJson: terapiaData.precioJson ? JSON.parse(terapiaData.precioJson) : { iess_n1: "", issfa_n1: "", issfa_n2: "", isspol_n1: "", particular: "" },
              estadoJson: terapiaData.estadoJson ? JSON.parse(terapiaData.estadoJson) : { iess: true, issfa: true, isspol: true, particular: true },
              establecimiento: {
              value : terapiaData.establecimiento.id ,
              text : terapiaData.establecimiento.Descripcion
            } ,
            tipoTerapia: {
              value : terapiaData.tipoTerapia.id,
              text : terapiaData.tipoTerapia.descripcion
            },
            };
            // Guardar los datos en el local storage
            localStorage.setItem("terapia", JSON.stringify(this.terapia));
          }
        } else {
          console.error("Error al obtener la terapia:", response.data.message);
        }
      } catch (error) {
        console.error("Error al realizar la consulta GraphQL:", error);
      }
    },
    clearLocalStorage() {
      // Eliminar los datos del local storage
      localStorage.removeItem("terapia");
    },
  },
};
</script>

<style>
/* Estilos personalizados si son necesarios */
</style>
